export default __webpack_public_path__ + "static/media/images.cb9b5a43.svg";